import { Injectable } from '@angular/core';
import { AppCacheService, CacheEntry, ClientOrigin } from '../../../cache/app-cache.service';

const LAST_VIEWED_OPPORTUNITY_PIPELINE = ClientOrigin.LAST_VIEWED_PIPELINE;

@Injectable()
export class SelectedPipelineCacheService {
  constructor(private readonly appCache: AppCacheService) {}

  get lastViewedPipeline(): string {
    return this.appCache.get(LAST_VIEWED_OPPORTUNITY_PIPELINE).value;
  }

  setLastViewedPipeline(pipelineID: string): void {
    const entry = <CacheEntry>{
      origin: LAST_VIEWED_OPPORTUNITY_PIPELINE,
      value: JSON.stringify(pipelineID),
    };
    this.appCache.add(entry);
  }
}
